/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFlipVertical = createReactComponent("outline", "flip-vertical", "IconFlipVertical", [["path", { "d": "M12 3l0 18", "key": "svg-0" }], ["path", { "d": "M16 7l0 10l5 0l-5 -10", "key": "svg-1" }], ["path", { "d": "M8 7l0 10l-5 0l5 -10", "key": "svg-2" }]]);

export { IconFlipVertical as default };
//# sourceMappingURL=IconFlipVertical.mjs.map
